// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"styles_sidebar__UvS2N","sidebar__sectors":"styles_sidebar__sectors__yDXP9","pulse":"styles_pulse__qxX2A","jump":"styles_jump__nKeGo"};